import axios from '@/axios'

export default {
	namespaced: true,

	state: {
		contracts: []
	},

	actions: {
		fetchAll({ commit }, { clientId, contractNo, date, complete, page, perPage } = {}) {
			return axios.get('/delivery', {
				params: { clientId, contractNo, date, complete, sortByCreatedAt: true, nonDeleted: true, page, perPage }
			});
		},
		fetchById({ commit }, { id }) {
			return axios.get(`/delivery/${id}`);
		},

		create({ commit }, { contractNo, date, clientId, sale, items }) {
			return axios.post('/delivery', { contractNo, date, isDelivered: false, clientId, sale, items });
		},

		update({ commit }, { id, contractNo, date, clientId, sale, items }) {
			return axios.put(`/delivery/${id}`, { contractNo, date, isDelivered: false, clientId, sale, items });
		},

		updateStatus({ commit }, { id, isDelivered }) {
			return axios.put(`/delivery/${id}/status`, `${isDelivered}`, {
				headers: { 'Content-Type': 'application/json' }
			});
		},

		delete({ commit }, { id }) {
			return axios.delete(`/delivery/${id}`);
		}
	},
}